import {Box, Flex, Icon, useColorModeValue} from "@chakra-ui/react";

export const NavItem = ({icon, children, ...rest}) => {
    return (
        <Box
            as="a"
            href="#"
            style={{textDecoration: 'none'}}
            _focus={{boxShadow: 'none'}}>
            <Flex
                align="center"
                p="4"
                mx="4"
                borderRadius="lg"
                role="group"
                cursor="pointer"
                _hover={{
                    bg: useColorModeValue('gray.700', 'gray.200'),
                    color: useColorModeValue('white', 'black'),
                }}
                {...rest}>
                <Icon
                    mr="4"
                    fontSize="16"
                    _groupHover={{
                        color: useColorModeValue('white', 'black'),
                    }}
                    as={icon}
                />

                {children}
            </Flex>
        </Box>
    )
}